import $ from 'jquery';

function initFiltersResourceLoad() {
    //If there's a search query, show it to user
    var queryString = getQueryString();
    if (queryString.has('search')) {
        setQueryStringSearch(queryString);
    }

    //Determine active pagination
    if (queryString.has('pageNum')) {
        determineActivePagination(queryString.get('pageNum'))
    }
    else {
        determineActivePagination();
    }

    //This needs to be refactored for IE11. URLSearchParams doesn't have a safe fallback. 
    function getQueryString() {
        var searchQuery = window.location.search;
        var params = new URLSearchParams(searchQuery);

        return params;
    }

    function setQueryStringSearch(queryString) {
        $('#search-query').text(queryString.get('search'));
        $('#search-string').removeClass('d-none');
    }

    function determineActivePagination(pageNum = 1) {
        var paginationSelector = `#page-link-${pageNum}`;
        $(paginationSelector).addClass('pagination-active');
    }
}

initFiltersResourceLoad();